import React, { useRef, useState } from 'react'
import { FaCheck } from 'react-icons/fa'

export default function Checkbox({ text, name, onClick, }) {
    const [checked, setChecked] = useState(false)

    const inp = useRef()

    return (
        <label
            htmlFor={name}
            className='flex items-center overflow-hidden bg-white cursor-pointer'
        >
        <span className='flex items-center justify-center shrink-0 bg-gray-450 px-4 py-3'>
            <input
                onChange={val => setChecked(val.target.checked)}
                type="checkbox"
                name={name}
                ref={inp}
                onClick={(e) => onClick(e)}
                id={name}
                className='peer appearance-none w-3.5 h-3.5 bg-white rounded cursor-pointer checked:bg-primary checked:border-primary'
            />
        
            {checked && (
                <span className='absolute flex items-center justify-center'>
                    <FaCheck className='text-white text-[10px]' />
                </span>
            )}
        </span>

        <span className='px-3 text-sm text-gray-light'>
            {text}
        </span>
    </label>
    )

}